<div class="row align-items-center">
  <div class="col-sm-2 text-center">
    <!-- Dynamic Icon Based on Type -->
    <ng-container [ngSwitch]="data.type">
      <!--Success -->
      <img *ngSwitchCase="'success'" src="assets/images/success-dialog-img.svg" alt="Success" />

      <!-- Alert -->
      <img *ngSwitchCase="'alert'" src="assets/images/alert-dialog-img.svg" alt="Alert" />

      <!-- Error -->
      <img *ngSwitchCase="'error'" src="assets/images/error-dialog-img.svg" alt="Error" />

      <!-- Confirm -->
      <img *ngSwitchCase="'confirm'" src="assets/images/alert-dialog-img.svg" alt="Confirm" />
    </ng-container>
  </div>

  <div class="col-sm-8">
    <h2 mat-dialog-title>{{ data.title || 'Alert' }}</h2>
    <mat-dialog-content>
      <p>{{ data.message }}</p>
    </mat-dialog-content>
  </div>

  <div class="col-sm-2 text-end">
    <!-- Always show close button (except confirm type if you want to restrict it) -->
    <button  class="alert-dialog__close mat-icon-button" (click)="onCancel()">
      <img src="assets/images/closecross.svg" alt="Close" width="18" />
    </button>
  </div>
</div>

<mat-dialog-actions align="end" *ngIf="data.type !== 'success' && data.type !== 'error'">
  <ng-container *ngIf="data.type === 'confirm'">
    <button mat-button (click)="onCancel()">
      {{ data.cancelText || 'Cancel' }}
    </button>
    <button mat-button color="primary" (click)="onConfirm()">
      {{ data.confirmText || 'Submit' }}
    </button>
  </ng-container>

  <ng-container *ngIf="data.type === 'alert'">
    <button mat-button color="primary" (click)="onConfirm()">
      {{ data.confirmText || 'Okay' }}
    </button>
  </ng-container>
</mat-dialog-actions>
